<div class="container h-100 d-flex justify-content-center align-items-center">
  <div class="card">
    <div class="card-body">
      <h2 class="card-title mb-3">Login with 🦆</h2>
      <form [formGroup]="loginForm" (submit)="handleChange()">
        <div class="form-group">
          <label for="exampleInputEmail1">Email</label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            formControlName="email"
            (focusout)="focusOut($event)"
          />
          <p
            class="alert-danger small mt-2 pl-2"
            *ngIf="!status && status !== undefined"
          >
            Invalid Email
          </p>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Password</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            formControlName="password"
          />
        </div>
        <button type="submit" class="btn btn-primary">Submit</button>
      </form>
    </div>
    <p *ngIf="submitted" class="alert-info m-auto" style="max-width: 90%">
      {{ value | json }}
    </p>
  </div>
</div>
